
import { useEffect } from "react";
import logo from "../../img/Grey Logo.png";
import { FilterProject } from "../../Redux/Slice/login/loginSlice";
import { useDispatch, useSelector } from "react-redux";

export const Loader = () => {

  const dispatch = useDispatch();

  const containerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "var(--theme-loader-bg, #ffffff)",
  };

  const wrapperStyle = {
    position: "relative",
    width: "270px",
    height: "270px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  const rotatingTextStyle = {
    position: "absolute",
    width: "100%",
    height: "100%",
    animation: "spinText 7s linear infinite",
  };

  const imageStyle = {
    width: "80px",
    height: "80px",
    objectFit: "contain",
    position: "absolute",
    zIndex: 2,
  };

  const keyframesStyle = `
    @keyframes spinText {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }
  `;


  return (
    <div style={containerStyle}>
      <div style={wrapperStyle}>
        <svg viewBox="0 0 320 320" style={rotatingTextStyle}>
          <defs>
            {/* Top arc */}
            <path
              id="topArc"
              d="M 55 160 A 105 105 0 0 1 265 160"
              fill="none"
            />

            {/* Bottom arc */}
            <path
              id="bottomArc"
              d="M 265 160 A 105 105 0 0 1 55 160"
              fill="none"
            />
          </defs>

          {/* Top text */}
          <text
            fill="#8c8c8c"
            fontSize="26"
            fontWeight="700"
            letterSpacing="4"
            fontFamily="'Trebuchet MS', 'Arial Rounded MT Bold', Arial, sans-serif"
          >
            <textPath href="#topArc" startOffset="50%" textAnchor="middle"  >
              Dynamic Softlink
            </textPath>
          </text>

          {/* Bottom text */}
          <text
            fill="#8c8c8c"
            fontSize="18"
            fontWeight="400"
            letterSpacing="2.5"
            fontFamily="'Trebuchet MS', Arial, sans-serif"
          >

            <textPath href="#bottomArc" startOffset="52%" textAnchor="middle">
              Solution is just a click away 
            </textPath>


          </text>
        </svg>

        <img src={logo} alt="Logo" style={imageStyle} />
      </div>

      <style>{keyframesStyle}</style>
    </div>
  );
};

